// extracted by mini-css-extract-plugin
export var deleteModal = "_ss-0";